var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "organization" },
    [
      _c("el-alert", {
        attrs: {
          title:
            "域 / 组独立于原部门；每人只能归属一个组，每组只能归属一个域。调整不会修改原部门、审批和考勤组。",
          closable: false,
        },
      }),
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.editDomain()
            },
          },
        },
        [_vm._v("新增域")]
      ),
      _vm._l(_vm.org.domains, function (d) {
        return _c(
          "div",
          { key: d.id, staticClass: "domain" },
          [
            _c(
              "h3",
              [
                _vm._v(_vm._s(d.name) + " "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.editDomain(d)
                      },
                    },
                  },
                  [_vm._v("编辑域")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.editGroup(null, d)
                      },
                    },
                  },
                  [_vm._v("新增组")]
                ),
              ],
              1
            ),
            _vm._l(
              _vm.org.groups.filter((x) => x.domainId === d.id),
              function (g) {
                return _c(
                  "el-button",
                  {
                    key: g.id,
                    on: {
                      click: function ($event) {
                        return _vm.selectGroup(g)
                      },
                    },
                  },
                  [
                    _vm._v(_vm._s(g.name) + " "),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.editGroup(g, d)
                          },
                        },
                      },
                      [_vm._v("✎")]
                    ),
                  ]
                )
              }
            ),
          ],
          2
        )
      }),
      _c("el-divider", [_vm._v("员工唯一归属")]),
      _c(
        "el-select",
        {
          attrs: { clearable: "", placeholder: "全部组" },
          on: { change: _vm.search },
          model: {
            value: _vm.filterGroup,
            callback: function ($$v) {
              _vm.filterGroup = $$v
            },
            expression: "filterGroup",
          },
        },
        _vm._l(_vm.org.groups, function (g) {
          return _c("el-option", {
            key: g.id,
            attrs: { label: _vm.label(g), value: g.id },
          })
        }),
        1
      ),
      _c(
        "el-checkbox",
        {
          on: { change: _vm.search },
          model: {
            value: _vm.unclassified,
            callback: function ($$v) {
              _vm.unclassified = $$v
            },
            expression: "unclassified",
          },
        },
        [_vm._v("只看未分组")]
      ),
      _c("el-input", {
        staticStyle: { width: "220px" },
        attrs: { placeholder: "姓名 / 工号" },
        nativeOn: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.search.apply(null, arguments)
          },
        },
        model: {
          value: _vm.keyword,
          callback: function ($$v) {
            _vm.keyword = $$v
          },
          expression: "keyword",
        },
      }),
      _c("el-button", { on: { click: _vm.search } }, [_vm._v("搜索")]),
      _c(
        "el-table",
        {
          attrs: { data: _vm.rows, "row-key": "id" },
          on: {
            "selection-change": function ($event) {
              _vm.selected = $event
            },
          },
        },
        [
          _c("el-table-column", { attrs: { type: "selection" } }),
          _c("el-table-column", { attrs: { prop: "name", label: "员工" } }),
          _c("el-table-column", { attrs: { prop: "serial", label: "工号" } }),
          _c("el-table-column", {
            attrs: { label: "当前归属" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [_vm._v(_vm._s(_vm.membership(row)))]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-button",
        { attrs: { disabled: _vm.done }, on: { click: _vm.more } },
        [_vm._v("加载更多员工")]
      ),
      _c(
        "div",
        { staticClass: "assign" },
        [
          _c(
            "el-select",
            {
              attrs: { clearable: "", placeholder: "留空表示移出原组" },
              model: {
                value: _vm.target,
                callback: function ($$v) {
                  _vm.target = $$v
                },
                expression: "target",
              },
            },
            _vm._l(_vm.org.groups, function (g) {
              return _c("el-option", {
                key: g.id,
                attrs: { value: g.id, label: _vm.label(g) },
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                disabled: !_vm.selected.length || _vm.busy,
              },
              on: { click: _vm.assign },
            },
            [_vm._v("调整所选 " + _vm._s(_vm.selected.length) + " 人的归属")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            "append-to-body": "",
            title: "组织组",
            visible: _vm.groupOpen,
          },
          on: {
            "update:visible": function ($event) {
              _vm.groupOpen = $event
            },
          },
        },
        [
          _c("el-input", {
            attrs: { maxlength: "80", placeholder: "组名称" },
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
          _c(
            "el-select",
            {
              attrs: { placeholder: "所属域" },
              model: {
                value: _vm.form.domainId,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "domainId", $$v)
                },
                expression: "form.domainId",
              },
            },
            _vm._l(_vm.org.domains, function (d) {
              return _c("el-option", {
                key: d.id,
                attrs: { label: d.name, value: d.id },
              })
            }),
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", disabled: _vm.busy },
                  on: { click: _vm.saveGroup },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }